import React from 'react';

import { retryableLazyImport } from '@/features/app/components/lazy-loader';

export const AutomationAddWizard = React.lazy(() =>
  retryableLazyImport(() => import('./automation-add-wizard'))
);

export const AutomationEditWizard = React.lazy(() =>
  retryableLazyImport(() => import('./automation-edit-wizard'))
);

export const AutomationTypeList = React.lazy(() =>
  retryableLazyImport(() => import('./automation-type-list'))
);

export const AutomationSettings = React.lazy(() =>
  retryableLazyImport(() => import('./automation-settings'))
);

export const AutomationConfirmation = React.lazy(() =>
  retryableLazyImport(() => import('./automation-confirmation'))
);

export const EmailTemplateSelect = React.lazy(() =>
  retryableLazyImport(() => import('./email-template-select'))
);

export const EmailTemplateName = React.lazy(() =>
  retryableLazyImport(() => import('./email-template-name'))
);

export const PipelineStageSelect = React.lazy(() =>
  retryableLazyImport(() => import('./pipeline-stage-select'))
);

export const PipelineStageName = React.lazy(() =>
  retryableLazyImport(() => import('./pipeline-stage-name'))
);

export const ScoreInput = React.lazy(() =>
  retryableLazyImport(() => import('./score-input'))
);

export const ScoreValue = React.lazy(() =>
  retryableLazyImport(() => import('./score-value'))
);

export const TimeInput = React.lazy(() =>
  retryableLazyImport(() => import('./time-input'))
);

export const TimeValue = React.lazy(() =>
  retryableLazyImport(() => import('./time-value'))
);

export const RejectedTag = React.lazy(() =>
  retryableLazyImport(() => import('./rejected-tag'))
);
